import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21423cce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mdm-l-login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Login", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please provide an API Key", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DodoButton = _resolveComponent("DodoButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_InputText, {
      modelValue: _ctx.apiKey,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apiKey) = $event)),
      type: "text"
    }, null, 8, ["modelValue"]),
    _hoisted_4,
    _hoisted_5,
    _createVNode(_component_DodoButton, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.login()))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Login ")
      ]),
      _: 1
    })
  ]))
}